// ErrorTooltip.tsx
import React from "react";
import { IoWarningOutline } from "react-icons/io5";

const IoWarningOut = IoWarningOutline as React.ComponentType;

interface Props {
    message: string;
}

export default function ErrorTooltip({ message }: Props) {
    return (
        <div className="absolute -top-1.5 left-[20%] bg-[#D34A4F] !font-normal text-white text-sm p-2 py-1 rounded-[5px] border border-red-600 flex items-center gap-2">
            {message}
            <span className="text-white text-lg"><IoWarningOut /></span>

            {/* Arrow */}
            <div className="absolute left-[48%] -bottom-1 w-3 h-3 bg-[#D34A4F] rotate-45 border-[#D34A4F]"></div>
        </div>
    );
}
